import { NgModule } from "@angular/core";
import { GenBreadcrumbModule } from "./breadcrumb/breadcrumb.module";
import { GenShippingAccountsModule } from "./shipping-accounts/shipping-accounts.module";
import { GenSubscriptionsModule } from "./subscriptions/subscriptions.module";
import { GenSharedModule } from "../shared/shared.module";
import { GenTabParagraphContainerModule } from "./tab-paragraph-container/tab-paragraph-container.module";
import { GenProductModule } from "./product/product.module";
import { GenSavedAddressesModule } from "./saved-addresses/saved-addresses.module";
import { GenOrderModule } from "./order/order.module";
import { GenCheckoutModule } from "./checkout/checkout.module";
import { GenFooterNavigationModule } from "./footer-navigation/footer-navigation.module";
import { GenProductImageZoomFeatureModule } from "./product/product-image-zoom-feature.module";
import { GenThemeModule } from "./theme/theme.module";
import { GenFavoritesModule } from "./favorites/favorites.module";
import { GenCategoryNavigationModule } from "./category-navigation/category-navigation.module";
import { GenUserAccountModule } from "./user-account/user-account.module";
import { GenQuickOrderModule } from "./quick-order/quick-order.module";
import { GenCartBaseFeatureModule } from "./cart/cart-base-feature.module";
import { GenCartSavedCartFeatureModule } from "./saved-cart/cart-saved-cart-feature.module";
import { GenCartBaseModule } from "./cart/cart-base.module";
import { GenProductCarouselComponent } from "./product/product-carousel/product-carousel.component";
import { GenDealerAcquisitionProductsModule } from "./dealer-acquisition-products/dealer-acquisition-products.module";
import { GenSpecialProgramModule } from "./special-program/special-program.module";
import { GenQuickOrderLinkModule } from './quick-order-link/quick-order-link.module'
import { GenMiniCartModule } from "./mini-cart/mini-cart.module";
import { GenAutoShipProductsModule } from "./auto-ship/auto-ship.module";
import { provideConfig, I18nConfig } from "@spartacus/core";
import { genTranslationsEn } from "src/assets/i18n/gen-translations";
import { genTranslationChunksConfig } from "src/assets/i18n/gen-translations-chunks.config";
import '../models/spartacus-augmented.model';

@NgModule({
  imports: [
    GenCartBaseModule,
    GenUserAccountModule,
    GenCheckoutModule,
    GenCategoryNavigationModule,
    GenProductModule,
    GenProductCarouselComponent,
    GenSubscriptionsModule,
    GenSharedModule,
    GenQuickOrderModule,
    GenOrderModule,
    GenFooterNavigationModule,
    GenProductImageZoomFeatureModule,
    GenThemeModule,
    GenFavoritesModule,
    GenShippingAccountsModule,
    GenTabParagraphContainerModule,
    GenCartBaseFeatureModule,
    GenBreadcrumbModule,
    GenSavedAddressesModule,
    GenCartSavedCartFeatureModule,
    GenDealerAcquisitionProductsModule,
    GenSpecialProgramModule,
    GenQuickOrderLinkModule,
    GenMiniCartModule,
    GenAutoShipProductsModule,
  ],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: genTranslationsEn },
        chunks: genTranslationChunksConfig,
        fallbackLang: 'en'
      },
    })
  ]
})
export class GenFeaturesModule { }
